module.exports = __webpack_public_path__ + "static/media/slide3.2c6241f6.gif";